import { IColumn } from '../types'

export const prepareStickyColumns = (
  column: IColumn,
  columns: IColumn[] | undefined,
  hasHierarchy?: boolean
) => {
  const stickyColumns = columns?.filter((item) => item.isStickyColumn)

  if (!stickyColumns?.length) {
    return {
      leftColumnShift: 0,
      isLastStickyColumn: false,
    }
  }

  const currentColumnIndex = stickyColumns.findIndex((col) => col.field === column.field)

  let leftColumnShift = 0
  for (let i = 0; i < currentColumnIndex; i++) {
    if (stickyColumns[i].width) {
      leftColumnShift += Number(stickyColumns[i].width)
    }
  }

  return {
    leftColumnShift: hasHierarchy ? leftColumnShift + 36 : leftColumnShift,
    isLastStickyColumn: currentColumnIndex === stickyColumns.length - 1,
  }
}
